<template>
  <div class="eight-line-spinner">
    <div v-for="index in 8" 
      :key="index" 
      :class="'line line-' + index"></div>
    {{ text }}  
  </div>
</template>


<script>
export default {
  name: "Spinner",
  props:["text"]
};
</script>


<style scoped>
.eight-line-spinner {
  display: inline-block;
  position: relative;
  width: 40px;
}

.line {
  position: absolute;
  width: 10px;
  height: 3px;
  background: #ccc;
  border-radius: 2px;
  transform-origin: 130%;
  opacity: 0.1;
  animation: fade 1.2s infinite;
}

@keyframes fade {
  0% {
    opacity: 0.1;
  }
  12.5% {
    opacity: 1;
  }
  100% {
    opacity: 0.1;
  }
}

.line-1 {
  transform: rotate(0deg);
  animation-delay: -1.05s;
}
.line-2 {
  transform: rotate(45deg);
  animation-delay: -0.9s;
}
.line-3 {
  transform: rotate(90deg);
  animation-delay: -0.75s;
}
.line-4 {
  transform: rotate(135deg);
  animation-delay: -0.6s;
}
.line-5 {
  transform: rotate(180deg);
  animation-delay: -0.45s;
}
.line-6 {
  transform: rotate(225deg);
  animation-delay: -0.3s;
}
.line-7 {
  transform: rotate(270deg);
  animation-delay: -0.15s;
}
.line-8 {
  transform: rotate(315deg);
}
</style>